import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCsLiveChat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M9.134 5.085c.916-.187 1.938-.335 2.866-.335.928 0 1.95.148 2.866.335A3.863 3.863 0 0 1 17.8 7.76c.159.526.29 1.047.355 1.493.073.498.097 1.123.095 1.745a.75.75 0 0 0 1.5.006c.002-.65-.022-1.362-.111-1.97a12.331 12.331 0 0 0-.403-1.707 5.363 5.363 0 0 0-4.07-3.71C14.203 3.418 13.07 3.25 12 3.25c-1.07 0-2.202.168-3.167.366a5.363 5.363 0 0 0-4.07 3.71c-.168.56-.321 1.16-.402 1.708-.089.607-.113 1.319-.11 1.969a.75.75 0 0 0 1.5-.006c-.003-.622.021-1.247.094-1.745.066-.446.196-.967.355-1.493a3.863 3.863 0 0 1 2.934-2.674Zm7.962 15.503a2.812 2.812 0 0 0 2.65-2.506l-1.491-.164a1.311 1.311 0 0 1-1.235 1.172c-1.443.073-3.486.16-5.02.16a.75.75 0 1 0 0 1.5c1.575 0 3.65-.088 5.096-.162Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M5.5 10.25a3.25 3.25 0 0 0-3.25 3.25v2a3.25 3.25 0 0 0 6.5 0v-2a3.25 3.25 0 0 0-3.25-3.25ZM3.75 13.5a1.75 1.75 0 1 1 3.5 0v2a1.75 1.75 0 1 1-3.5 0v-2Zm14.75-3.25a3.25 3.25 0 0 0-3.25 3.25v2a3.25 3.25 0 0 0 6.5 0v-2a3.25 3.25 0 0 0-3.25-3.25Zm-1.75 3.25a1.75 1.75 0 1 1 3.5 0v2a1.75 1.75 0 1 1-3.5 0v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorCsLiveChat;
